import { FieldError, UseFormRegisterReturn } from "react-hook-form";

interface FormTextareaProps {
  label?: string;
  placeholder?: string;
  register?: UseFormRegisterReturn;
  error?: FieldError;
  rows?: number;
}

const FormTextarea = ({
  label,
  placeholder,
  register,
  error,
  rows = 4,
}: FormTextareaProps) => (
  <div className="flex flex-col gap-1.5">
    {label && <label className="text-sm text-[#4A4A4A]">{label}</label>}
    <textarea
      placeholder={placeholder}
      rows={rows}
      {...register}
      className={`w-full px-4 py-3 rounded-lg border bg-[#FAFAFA] text-sm text-dark-100 placeholder:text-[#BDBDBD] outline-none focus:border-[#CBA135] transition-colors resize-none ${
        error ? "border-red-400 focus:border-red-400" : "border-[#E0E0E0]"
      }`}
    />
    {error && <p className="text-xs text-red-500">{error.message}</p>}
  </div>
);

export default FormTextarea;
